import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProductSearch from 'app-components/Products/Search/ProductSearch.jsx';

class ProductHome extends React.Component {


    render() {
        return (
            <div className="main-content">
                <ProductSearch showNotification={this.props.showNotification}/>
            </div>
        )
    }
}

ProductHome.propTypes = {
    showNotification: PropTypes.func
};

export default connect()(ProductHome);
